export default {
      id: "deco-usage",
      viewBox: "0 0 895 1165",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco-usage",
      toString: function () {
        return this.url;
      }
    }